import * as React from "react";
import C from "classnames";
import { Link } from "react-router-dom";
export const NavBrand = (props) => {
    return props.to ? (React.createElement(Link, { className: C("navbar-brand mr-auto", props.className), to: props.to, "data-testid": props.testId, style: { width: props.width } }, props.children)) : (React.createElement("a", { className: C("navbar-brand mr-auto", props.className), href: props.href, style: { width: props.width }, "data-testid": props.testId }, props.children));
};
//# sourceMappingURL=NavBrand.js.map